import {PageWithLayout, requireUnauth} from "../Page";
import {Navigate} from "react-router-dom";
import {SetNewPassword} from "../../components/reset-password/SetNewPassword";
import {CentralContent} from "../../components/central-content/CentralContent";

export const EmailActionsPage = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const mode = searchParams.get("mode");
  if (mode != "resetPassword") {
    return <Navigate to="/error?error=invalid_email_action"/>
  }
  const oobCode = searchParams.get("oobCode");
  if (!oobCode) {
    return <Navigate to="/error?error=oob_code_missing"/>
  }

  const pageContent = <PageWithLayout variant="secondary" showHeader={true} stickContentToTop={false}>
    <CentralContent>
        <SetNewPassword oobCode={oobCode}/>
    </CentralContent>
  </PageWithLayout>

  return (
      requireUnauth(pageContent)
  )
};
